import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule,JsonpModule } from '@angular/http';
import {SanitizeHtmlPipe} from 'app/utils/sanatize-pipe';


//import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome'
//import { RouterModule, Routes } from '@angular/router';


import { AppComponent } from './app.component';
import { CategoryListComponent } from './category/category-list.component';
import { CategoryDataService} from './category/category-data.service';
import { CategoryItemComponent} from './category/category-item.component';
import { MyHtml } from "./utils/html.component";





/*
const appRoutes: Routes = [
  { path: '/', component: SplashComponent },
  { path: '/menu',      component: AppComponent},
  { path: '',
    redirectTo: '/menu',
    pathMatch: 'full'
  },

];
*/

@NgModule({
  declarations: [
    AppComponent,
    CategoryListComponent,
    CategoryItemComponent,
    SanitizeHtmlPipe,
    MyHtml


  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule

    //RouterModule.forRoot(appRoutes)

    //AngularFireModule.initializeApp(firebaseConfig)
  ],
  providers: [CategoryDataService],
  bootstrap: [AppComponent ]
})
export class AppModule { }






// WEBPACK FOOTER //
// ./src/app/app.module.ts